import request from '@/utils/request'
const BASE_URL = '/Article'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  // getReviewCount() {
  //   return request({
  //     url: BASE_URL + '/GetReviewCount',
  //     method: 'get',
  //   })
  // },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  // pass(id) {
  //   return request({
  //     url: BASE_URL + '/Pass',
  //     method: 'post',
  //     data: id
  //   })
  // },
  // back(data) {
  //   return request({
  //     url: BASE_URL + '/Back',
  //     method: 'post',
  //     data
  //   })
  // },
  // cancel(data) {
  //   return request({
  //     url: BASE_URL + '/Cancel',
  //     method: 'post',
  //     data
  //   })
  // },
  // cancelPublish(data) {
  //   return request({
  //     url: BASE_URL + '/CancelPublish',
  //     method: 'post',
  //     data
  //   })
  // },
  // getIndexStat() {
  //   return request({
  //     url: BASE_URL + '/GetIndexStat',
  //     method: 'get',
  //   })
  // }
}